import ThemeConfig from '@assets/theme';
import { LinearProgress } from '@material-ui/core';
import { DealPage } from '@pages/DealPage';
import ErrorBoundary from '@settings/ErrorBoundary';
import ErrorController from '@settings/ErrorController';
import { SnackbarProvider } from 'notistack';
import React, { Suspense } from 'react';

function PointDealPage() {
  return (
    <ThemeConfig containerId="onlog-deal-page-container">
      <Suspense fallback={<LinearProgress />}>
        <SnackbarProvider maxSnack={10} preventDuplicate={true} autoHideDuration={3000}>
          <ErrorBoundary needJSX={true}>
            <DealPage />
            <ErrorController />
          </ErrorBoundary>
        </SnackbarProvider>
      </Suspense>
    </ThemeConfig>
  );
}

export default PointDealPage;
